import { info_icon } from 'constant/AllIcons'
import { pricing_plans } from 'data/PringPlanData'
import Link from 'next/link'
import React from 'react'

const SMEPricingModel2 = ({ is_annual, userDetails, tenantDetails }) => {
  return (
    <div className=" grid  grid-cols-1 md:grid-cols-2 lg:grid-cols-4  gap-[11px]">
      {pricing_plans?.map((item, index) => {
        return (
          <div
            className={
              'relative flex flex-col h-full py-8 px-6 rounded-2xl bg-white shadow-xl  border border-[#eaecf0] '
            }
          >
            <div className="mb-4">
              <div className=" flex items-center justify-between mb-2">
                <h2 className="h2 !text-2xl !font-semibold">{item?.title}</h2>
                {item?.is_show_star && (
                  <p className=" text-sm px-2 text-primary bg-primary/20 rounded-2xl">Popular</p>
                )}
              </div>
              <p className=" text-lightGray text-sm font-medium  leading-[27px] min-h-[108px] text">
                {item?.description}
              </p>
            </div>

            <hr className="my-8 w-full h-[1px] bg-[#eaecf0]" />

            {/* price */}
            <div className="inline-flex items-baseline my-2">
              <h3 className="h3">
                {item?.price?.dollar_sign}
                {is_annual ? item.price.true : item.price.false}
              </h3>
              <span className="text-gray-900  text-sm font-semibold ml-1">USD</span>
            </div>
            <p className=" text-lightGray text-sm font-medium">per month</p>
            <p className=" text-lightGray text-sm font-medium">
              {is_annual ? 'billed yearly' : 'billed monthly'}
            </p>

            <hr className="my-8 w-full h-[1px] bg-[#eaecf0]" />

            {/*  */}
            <ul className="text-gray-900 -mb-2 flex-grow flex flex-col gap-4">
              {item?.features?.map((feature) => {
                return (
                  <li className="flex items-center gap-3 ">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
                        fill="#D1FADF"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M17.096 7.39004L9.93602 14.3L8.03602 12.27C7.68602 11.94 7.13602 11.92 6.73602 12.2C6.34602 12.49 6.23602 13 6.47602 13.41L8.72602 17.07C8.94602 17.41 9.32601 17.62 9.75601 17.62C10.166 17.62 10.556 17.41 10.776 17.07C11.136 16.6 18.006 8.41004 18.006 8.41004C18.906 7.49004 17.816 6.68004 17.096 7.38004V7.39004Z"
                        fill="#12B76A"
                      ></path>
                    </svg>

                    {feature?.link ? (
                      <Link href={feature?.link}>
                        <a className="text-lightGray text-sm font-medium flex-grow underline">
                          {feature?.title}
                        </a>
                      </Link>
                    ) : (
                      <span className="text-lightGray text-sm font-medium flex-grow">
                        {feature?.title}
                      </span>
                    )}
                    {feature?.info && (
                      <div className="ml-1 group">
                        <span className=" cursor-pointer">{info_icon}</span>
                        <span className=" hidden  absolute group-hover:block bg-gray-600 text-gray-50 text-sm  mt-2 text-start p-2 z-20 rounded-md max-w-xs w-full right-0">
                          {feature?.info}
                        </span>
                      </div>
                    )}
                  </li>
                )
              })}
            </ul>
          </div>
        )
      })}
    </div>
  )
}

export default SMEPricingModel2
